// ชั้นตราเครื่องราชอิสริยาภรณ์ตามลำดับข้อ ๑๑ ระเบียบสำนักนายกรัฐมนตรีฯ พ.ศ. ๒๕๖๔
// ต้องตรงกับ DEC_CLASSES ใน HRvec_api/decoration_helpers.php (ฝั่งเซิร์ฟเวอร์เป็นผู้ตัดสินคุณสมบัติ)

export const CLASSES = [
  ["ร.ง.ม.", "เหรียญเงินมงกุฎไทย", "ม"],
  ["ร.ง.ช.", "เหรียญเงินช้างเผือก", "ช"],
  ["ร.ท.ม.", "เหรียญทองมงกุฎไทย", "ม"],
  ["ร.ท.ช.", "เหรียญทองช้างเผือก", "ช"],
  ["บ.ม.", "เบญจมาภรณ์มงกุฎไทย", "ม"],
  ["บ.ช.", "เบญจมาภรณ์ช้างเผือก", "ช"],
  ["จ.ม.", "จัตุรถาภรณ์มงกุฎไทย", "ม"],
  ["จ.ช.", "จัตุรถาภรณ์ช้างเผือก", "ช"],
  ["ต.ม.", "ตริตาภรณ์มงกุฎไทย", "ม"],
  ["ต.ช.", "ตริตาภรณ์ช้างเผือก", "ช"],
  ["ท.ม.", "ทวีติยาภรณ์มงกุฎไทย", "ม"],
  ["ท.ช.", "ทวีติยาภรณ์ช้างเผือก", "ช"],
  ["ป.ม.", "ประถมาภรณ์มงกุฎไทย", "ม"],
  ["ป.ช.", "ประถมาภรณ์ช้างเผือก", "ช"],
  ["ม.ว.ม.", "มหาวชิรมงกุฎ", "ม"],
  ["ม.ป.ช.", "มหาปรมาภรณ์ช้างเผือก", "ช"]
].map(([abbr, name, family], order) => ({ abbr, name, family, order, text: `${name} (${abbr})` }));

export function classInfo(abbr) {
  return CLASSES.find(c => c.abbr === abbr) || null;
}

export function className(abbr) {
  const c = classInfo(abbr);
  return c ? c.name : abbr || "";
}

/** ชื่อเครื่องราชฯ ตามตระกูลของชั้นตรา */
export function orderName(abbr) {
  const c = classInfo(abbr);
  if (!c) return "";
  return c.family === "ช"
    ? "เครื่องราชอิสริยาภรณ์อันเป็นที่เชิดชูยิ่งช้างเผือก"
    : "เครื่องราชอิสริยาภรณ์อันมีเกียรติยศยิ่งมงกุฎไทย";
}

/** ชั้นสายสะพาย (ป.ม. ขึ้นไป) — ข้อ ๑๓ แยกเอกสาร */
export function isSash(abbr) {
  const c = classInfo(abbr);
  return !!c && c.order >= classInfo("ป.ม.").order;
}

// ผลตรวจคุณสมบัติ (decEvaluate.status)
export const STATUS = {
  eligible: { label: "ครบเกณฑ์", color: "success", icon: "mdi-check-decagram" },
  review: { label: "ครบเกณฑ์ — ต้องตรวจสอบ", color: "amber darken-2", icon: "mdi-alert-decagram" },
  not_yet: { label: "ยังไม่ครบเกณฑ์", color: "blue-grey", icon: "mdi-timer-sand" },
  max_reached: { label: "ถึงชั้นสูงสุดตามตำแหน่ง", color: "deep-purple", icon: "mdi-crown" },
  need_data: { label: "ข้อมูลไม่พอ", color: "orange darken-2", icon: "mdi-database-alert" },
  not_covered: { label: "ไม่อยู่ในเกณฑ์", color: "grey", icon: "mdi-minus-circle-outline" }
};

// การรับรองคุณสมบัติตามข้อ ๑๒ (key ต้องตรงกับ DEC_CERTIFY_KEYS ใน decoration_college.php)
export const CERTIFY_ITEMS = [
  { key: "thai", text: "มีสัญชาติไทย", ref: "ข้อ ๑๒ (๑)" },
  {
    key: "conduct",
    text: "เป็นผู้ประพฤติดี ปฏิบัติงานด้วยความอุตสาหะ ซื่อสัตย์ และเอาใจใส่ต่อหน้าที่อย่างดียิ่ง",
    ref: "ข้อ ๑๒ (๒)"
  },
  { key: "not_revoked", text: "ไม่เคยถูกเรียกคืนเครื่องราชอิสริยาภรณ์ (เว้นแต่ได้รับพระราชทานคืน)", ref: "ข้อ ๑๒ (๔)" },
  {
    key: "no_prison",
    text: "ไม่เคยต้องรับโทษจำคุกโดยคำพิพากษาถึงที่สุด (เว้นแต่ความผิดโดยประมาทหรือลหุโทษ)",
    ref: "ข้อ ๑๒ (๕)"
  },
  {
    key: "no_pending",
    text: "ไม่อยู่ระหว่างถูกกล่าวหาว่ากระทำผิดวินัยอย่างร้ายแรง/คดีอาญา/ถูกไต่สวนการทุจริต",
    ref: "ข้อ ๑๒ (๖)"
  },
  {
    key: "no_delay",
    text: "ตรวจแล้วไม่มีกรณีต้องเพิ่มระยะเวลา (ถูกลงโทษทางวินัย / ผลประเมินต่ำกว่าระดับดี) หรือได้นับเพิ่มแล้ว",
    ref: "ข้อ ๑๘"
  },
  { key: "self_signed", text: "บุคคลลงนามในแบบรับรองคุณสมบัติตนเองแล้ว", ref: "ข้อ ๑๒ วรรคสอง" }
];

export function certifyComplete(certify) {
  return CERTIFY_ITEMS.every(i => certify && certify[i.key]);
}

/** วันที่ Y-m-d (ค.ศ.) → "28 ก.ค. 2570" */
export function thaiDate(ymd) {
  if (!ymd) return "-";
  const m = ["", "ม.ค.", "ก.พ.", "มี.ค.", "เม.ย.", "พ.ค.", "มิ.ย.", "ก.ค.", "ส.ค.", "ก.ย.", "ต.ค.", "พ.ย.", "ธ.ค."];
  const [y, mo, d] = String(ymd)
    .substr(0, 10)
    .split("-")
    .map(Number);
  if (!y || !mo || !d) return "-";
  return `${d} ${m[mo]} ${y + 543}`;
}

export function thaiDateLong(ymd) {
  if (!ymd) return "-";
  const m = ["", "มกราคม", "กุมภาพันธ์", "มีนาคม", "เมษายน", "พฤษภาคม", "มิถุนายน", "กรกฎาคม", "สิงหาคม",
    "กันยายน", "ตุลาคม", "พฤศจิกายน", "ธันวาคม"];
  const [y, mo, d] = String(ymd)
    .substr(0, 10)
    .split("-")
    .map(Number);
  if (!y || !mo || !d) return "-";
  return `${d} ${m[mo]} ${y + 543}`;
}
